import React, { KeyboardEvent, MouseEvent } from "react";
import styles from "./back-icon-button-with-text.module.scss";
import backArrowBlue from "@src/assets/svg/back-arrow-blue.svg";
import { useI18N } from "@src/language/language-context";

interface BackIconButtonWithTextPropTypes {
  fun: (e: MouseEvent | KeyboardEvent) => void;
  text: string;
}

const cssClassName = "back-icon-button-with-text";

export const BackIconButtonWithText = ({
  fun,
  text,
}: BackIconButtonWithTextPropTypes) => {
  const i18n = useI18N();
  const texts = {
    backButtonAltText: i18n("modules.backIconButtonWithText.backButtonAltText"),
  };

  return (
    <button onClick={fun} className={styles[cssClassName]}>
      <img
        className={styles[`${cssClassName}__icon`]}
        src={backArrowBlue}
        alt={texts.backButtonAltText}
      />
      <span className={styles[`${cssClassName}__text`]}>{text}</span>
    </button>
  );
};
